export const AUTH_APP_ID_KEY = 'auth_app_id';
